import { ErrorCode, useDropzone } from 'react-dropzone';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';

const LUBRICATION_CHART_MAX_SIZE = 5e6; // 5 MB

export const useLubricationChartDropzone = (onFilesDrop: (droppedFiles: File[]) => void) => {
    const { addErrorToast } = useToasts();

    return useDropzone({
        onDrop: (files) => {
            if (files.length > 0) {
                onFilesDrop(files);
            }
        },
        onDropRejected: (rejections) => {
            const firstError = rejections?.[0]?.errors?.[0]?.code as ErrorCode | undefined;

            let firstErrorTranslation = translate('vessel.products.toasts.dropzone.unknownError');

            if (firstError) {
                switch (firstError) {
                    case ErrorCode.FileInvalidType:
                        firstErrorTranslation = translate('vessel.products.toasts.dropzone.invalidFileFormat');
                        break;
                    case ErrorCode.FileTooLarge:
                        firstErrorTranslation = translate('vessel.products.toasts.dropzone.invalidFileSize');
                        break;
                    case ErrorCode.TooManyFiles:
                        firstErrorTranslation = translate('vessel.products.toasts.dropzone.multipleFilesNotAllowed');
                        break;
                }
            }

            addErrorToast(firstErrorTranslation);
        },
        multiple: false,
        noClick: true,
        maxSize: LUBRICATION_CHART_MAX_SIZE,
        maxFiles: 1,
        accept: {
            'application/pdf': ['.pdf'],
            'image/*': ['.jpg', '.jpeg', '.png', '.bmp', '.webp'],
        },
    });
};
